import React, {Component} from 'react'
import * as actions from '../../actions'
import {connect} from 'react-redux'
import LoginHelper from "../../services/LoginHelper";

class Logout extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        //LoginHelper.logout()
        this.props.logoutUser();
        //this.props.router.push("/login");

    }

    render() {
        return <div></div>
    }
}

function mapStateToProps(state) {
    return {errorMessage: state.auth.error, authenticated: state.auth.authenticated};
}
export default connect(mapStateToProps, actions)(Logout);
